import React, { useState } from "react";
import {
  Container,
  Paper,
  TextField,
  Button,
  Typography,
  Snackbar,
  Alert,
  Switch,
  FormControlLabel,
  MenuItem,
} from "@mui/material";
import axiosInstance from "../../utils/axiosConfig";
import { useTranslation } from "react-i18next";

export const ChecklistQuestionManagement = () => {
  const { t } = useTranslation();
  const [newQuestion, setNewQuestion] = useState({
    question: "",
    order: "",
    active: true,
    service_type: "",
    input_type: "text",
  });

  const [notification, setNotification] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axiosInstance.post("/checklist_questions", {
        checklist_question: newQuestion,
      });

      setNotification({
        open: true,
        message: t("questionCreatedSuccessfully"),
        severity: "success",
      });
      setNewQuestion({
        question: "",
        order: "",
        active: true,
        service_type: "",
        input_type: "text",
      });
    } catch (error) {
      setNotification({
        open: true,
        message: error.message,
        severity: "error",
      });
    }
  };

  return (
    <Container maxWidth="sm">
      <Paper sx={{ p: 4, mt: 4 }}>
        <Typography variant="h5" gutterBottom>
          {t("createQuestion")}
        </Typography>
        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            label={t("question")}
            margin="normal"
            value={newQuestion.question}
            onChange={(e) =>
              setNewQuestion({ ...newQuestion, question: e.target.value })
            }
            required
          />
          <TextField
            fullWidth
            label={t("order")}
            margin="normal"
            type="number"
            value={newQuestion.order}
            onChange={(e) =>
              setNewQuestion({ ...newQuestion, order: e.target.value })
            }
            required
          />
          <TextField
            select
            fullWidth
            label={t("serviceType")}
            margin="normal"
            value={newQuestion.service_type}
            onChange={(e) =>
              setNewQuestion({ ...newQuestion, service_type: e.target.value })
            }
            required
          >
            <MenuItem value="preventivo">Preventivo Ascensor</MenuItem>
            <MenuItem value="correctivo">Correctivo Ascensor</MenuItem>
            <MenuItem value="instalacion">Instalación Ascensor</MenuItem>
            <MenuItem value="electric_plant">Preventivo Planta Eléctrica</MenuItem>
            <MenuItem value="electric_plant_correctivo">Correctivo Planta Eléctrica</MenuItem>
            <MenuItem value="electric_plant_instalacion">Instalación Planta Eléctrica</MenuItem>
            <MenuItem value="vehicular_door">Preventivo Puerta Vehicular</MenuItem>
            <MenuItem value="vehicular_door_correctivo">Correctivo Puerta Vehicular</MenuItem>
            <MenuItem value="vehicular_door_instalacion">Instalación Puerta Vehicular</MenuItem>
            <MenuItem value="escalator">Preventivo Escalera Electrica</MenuItem>
            <MenuItem value="escalator_correctivo">Correctivo Escalera Electrica</MenuItem>
            <MenuItem value="escalator_instalacion">Instalación Escalera Electrica</MenuItem>
          </TextField>
          <TextField
            select
            fullWidth
            label={t("inputType")}
            margin="normal"
            value={newQuestion.input_type}
            onChange={(e) =>
              setNewQuestion({ ...newQuestion, input_type: e.target.value })
            }
            required
          >
            <MenuItem value="text">Text</MenuItem>
            <MenuItem value="textarea">Textarea</MenuItem>
            <MenuItem value="number">Number</MenuItem>
            <MenuItem value="checkbox">Checkbox</MenuItem>
          </TextField>
          <FormControlLabel
            control={
              <Switch
                checked={newQuestion.active}
                onChange={(e) =>
                  setNewQuestion({ ...newQuestion, active: e.target.checked })
                }
              />
            }
            label={t("active")}
            sx={{ mt: 2 }}
          />
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            sx={{ mt: 2 }}
          >
            {t("createQuestion")}
          </Button>
        </form>
      </Paper>
      <Snackbar
        open={notification.open}
        autoHideDuration={6000}
        onClose={() => setNotification({ ...notification, open: false })}
      >
        <Alert severity={notification.severity} sx={{ width: "100%" }}>
          {notification.message}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default ChecklistQuestionManagement;
